import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { capitalizeFirstLetter, formateDateWithMonth, formateDateWithMonthAdmin, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import * as paymentService from "../../services/payment.services";
import { Placeholder } from "rsuite";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

const ViewPayment = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();

    const [showdefault, setShowDefault] = useState({});
    const [downloading, setDownloading] = useState(false);
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: t("Transactions"),
            url: "/admin/payment/list/1",
        },
        { title: t("btn_view"), url: "" },
    ];

    const getPaymentDetails = () => {
        paymentService
            .Details(params.id)
            .then((response) => {
                console.log("View response-", response);
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    };
    useEffect(() => {
        getPaymentDetails();
    }, [params.id]);

    const handleDownloadInvoice = async (paymentId) => {
        try {
            setDownloading(true);
            const res = await paymentService.DownloadInvoice(paymentId || params.id);
            setDownloading(false);
            if (res?.success && res?.data?.base64) {
                const byteCharacters = atob(res.data.base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/pdf" });
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = res.data.fileName || `Invoice_${paymentId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
                Swal.fire({
                    icon: "success",
                    title: "Invoice Downloaded",
                    text: `Invoice ${res.data.invoice_number || ""} downloaded successfully.`,
                    timer: 2200,
                    showConfirmButton: false,
                });
            } else if (res?.data?.invoice_url) {
                window.open(res.data.invoice_url, "_blank");
            } else {
                Swal.fire({
                    icon: "error",
                    text: res?.message || "Failed to download invoice",
                });
            }
        } catch (err) {
            setDownloading(false);
            console.error("Download invoice error:", err);
            Swal.fire({
                icon: "error",
                text: err?.message || "Error downloading invoice",
            });
        }
    };

    function handleRefund(paymentId, amount) {
        Swal.fire({
            customClass: "swal-wide",
            title: t("refund_msg_are_you_sure"),
            text: t("refund_you_not_be_able_to_revert_this"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("Refund"),
            cancelButtonText: t("Cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                paymentService
                    .Refund({
                        paymentId: paymentId,
                        amount: amount
                    })
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            getPaymentDetails();
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("deleteError");
                    });
            }
        });
    }

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">
                                    {t("View Transactions")}
                                </h6>
                            </div>
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>

                                                <tr>
                                                    <th>{t("list_heading_invoice_no", "Invoice Number")}</th>
                                                    <td className="font-weight-semibold">
                                                        {showdefault && showdefault.invoice_number
                                                            ? showdefault.invoice_number
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.name
                                                            ? capitalizeFirstLetter(showdefault.name)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_email")}</th>
                                                    <td>
                                                        {showdefault && showdefault.email
                                                            ? showdefault.email
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_phone")}</th>
                                                    <td>
                                                        {showdefault && showdefault.phone_number
                                                            ? showdefault.phone_number
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_state", "State")}</th>
                                                    <td>
                                                        {showdefault && (showdefault.state || showdefault.store_location?.state)
                                                            ? (showdefault.state || showdefault.store_location?.state)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Package Price(INR)")}</th>
                                                    <td>
                                                        {showdefault && showdefault.package_price
                                                            ? showdefault.package_price
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_package_name")}</th>
                                                    <td>
                                                        {showdefault && showdefault.package_name
                                                            ? showdefault.package_name
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_package_hours")}</th>
                                                    <td>
                                                        {showdefault && showdefault.package_hours
                                                            ? showdefault.package_hours
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_package_description")}</th>
                                                    <td>
                                                        {showdefault && showdefault.package_description
                                                            ? showdefault.package_description
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_razorpay_payment_id")}</th>
                                                    <td>
                                                        {showdefault && showdefault.razorpay_payment_id
                                                            ? showdefault.razorpay_payment_id
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_payment_status")}</th>
                                                    <td>
                                                        {showdefault && showdefault.payment_status
                                                            ? capitalizeFirstLetter(showdefault.payment_status)
                                                            : "N/A"}
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <th>{t("label_payment_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.createdAt
                                                            ? formateDateWithMonthAdmin(showdefault.createdAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                        </div>
                        <div className="d-flex">
                            <div className="mt-5 back-button">
                                <button
                                    className="btn ripple btn-dark"
                                    type="button"
                                    onClick={() =>
                                        navigate("/admin/payment/list/1")
                                    }
                                >
                                    <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                    {t("btn_back")}
                                </button>
                            </div>
                            <div className="mt-5 back-button">
                                <button
                                    className="btn ripple btn-success"
                                    type="button"
                                    onClick={() => handleDownloadInvoice(showdefault._id)}
                                    disabled={downloading}
                                >
                                    {downloading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            Downloading...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-file-pdf-o me-1"></i>
                                            Download Invoice
                                        </>
                                    )}
                                </button>
                            </div>
                            {showdefault?.payment_status == "completed" &&
                                <div className="mt-5 back-button">
                                    <button
                                        className="btn ripple btn-dark"
                                        type="button"
                                        onClick={() => handleRefund(showdefault._id, showdefault.package_price)}
                                    >
                                        Refund
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewPayment;
